import http from '@/utils/http';

const PROXY = '/proxy';

const API = {

  // 获取建筑详情
  getBuildDetail (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/build/detail', data, option);
  },
  // 获取顶部POI列表（带图标）
  poiTopList (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/poiSearch/topList', data, option);
  },
  // 获取顶部POI列表（带图标）
  searchPoi (data = {}, option = {}) {
    return http.post(PROXY + '/api/loca/beacon/search', data, option);
  },
  // 获取顶部POI列表（带图标）
  queryShortPath (data = {}, option = {}) {
    return http.post(PROXY + '/api/loca/path/queryShortPath', data, option);
  },
  // 查询建筑节点
  queryNode (data = {}, option = {}) {
    return http.post(PROXY + '/api/loca/beacon/queryNode', data, option);
  },
  // 查询楼栋信息
  queryPolygonList (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/region/list', data, option);
  },
  // 查询POI分组信息
  queryGroupList (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/poiSearch/groupList', data, option);
  },
  // 拼音查询poi
  pinyingPoi (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/poiSearch/pinyinglist', data, option);
  },
  // 查询科室列表（1级）
  queryDeptList (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/dept/list', data, option);
  },
  // 查询科室列表（2级）
  queryDeptList2 (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/poiOrm/listDeptOrm', data, option);
  },
  // 查询所有POI
  queryAllPoiList (data = {}, option = {}) {
    return http.post(PROXY + '/api/cust/poiItem/listAll', data, option);
  }

};

export default API;
